/* ShopKitchens targeted storefront corrections + selected-variant collection add to cart */
(() => {
  'use strict';

  const DARK='#242424', LIGHT='#ffffff', START_PAGE='/pages/start-your-kitchen';
  const STYLE_KEY='k4lCabinetStyle', BOX_KEY='k4lCabinetBox', ACTIVE_KEY='k4lKitchenShoppingActive';
  const productCache=new Map();
  const norm=v=>(v||'').toLowerCase().replace(/3\/4|¾/g,'').replace(/[^a-z0-9]+/g,' ').trim();
  const textOf=el=>(el&&el.textContent?el.textContent:'').trim().replace(/\s+/g,' ');

  function setColor(el,color){
    if(!el)return;
    el.style.setProperty('color',color,'important');
    el.style.setProperty('opacity','1','important');
    el.style.setProperty('text-shadow','none','important');
    el.querySelectorAll('span,strong,em').forEach(c=>{c.style.setProperty('color',color,'important');c.style.setProperty('opacity','1','important');c.style.setProperty('text-shadow','none','important')});
  }

  function selection(){
    const u=new URL(location.href), us=u.searchParams.get('style_name'), ub=u.searchParams.get('box_type');
    if(us||ub){
      if(us)sessionStorage.setItem(STYLE_KEY,us);
      if(ub)sessionStorage.setItem(BOX_KEY,ub);
      sessionStorage.setItem(ACTIVE_KEY,'1');
    }
    if(sessionStorage.getItem(ACTIVE_KEY)!=='1')return null;
    const style=us||sessionStorage.getItem(STYLE_KEY), box=ub||sessionStorage.getItem(BOX_KEY);
    return style&&box?{style,box}:null;
  }

  function finishColor(style){
    const s=norm(style);
    if(s.includes('pure white')||s.includes('white'))return '#f2f1ec';
    if(s.includes('grey')||s.includes('gray'))return '#969792';
    if(s.includes('blue'))return '#65788d';
    if(s.includes('black')||s.includes('charcoal'))return '#303234';
    if(s.includes('green'))return '#748277';
    if(s.includes('cream')||s.includes('beige')||s.includes('ivory'))return '#d9ceb9';
    if(s.includes('walnut'))return '#765b48';
    if(s.includes('oak')||s.includes('maple')||s.includes('wood'))return '#b89169';
    return '#d8d5ce';
  }

  function doorClass(style){
    const s=norm(style);
    if(s.includes('slim shaker')||s.includes('skinny shaker'))return 'k4l-slim-shaker';
    if(s.includes('shaker'))return 'k4l-shaker';
    return 'k4l-flat-door';
  }

  function selectedDoorVisual(chosen){
    const config=document.createElement('div');
    config.className='k4l-door-selection';
    config.setAttribute('aria-label',`Selected cabinet door: ${chosen.style}; box: ${chosen.box}`);

    const door=document.createElement('span');
    door.className=`k4l-door-preview ${doorClass(chosen.style)}`;
    door.style.setProperty('--k4l-door-color',finishColor(chosen.style));
    door.setAttribute('aria-hidden','true');

    const copy=document.createElement('span');
    copy.className='k4l-door-copy';
    const eyebrow=document.createElement('span');
    eyebrow.className='k4l-door-eyebrow';
    eyebrow.textContent='Your selected door';
    const name=document.createElement('strong');
    name.className='k4l-door-name';
    name.textContent=chosen.style;
    const box=document.createElement('small');
    box.className='k4l-door-box';
    box.textContent=chosen.box;
    copy.append(eyebrow,name,box);
    config.append(door,copy);
    return config;
  }

  async function getProduct(path){
    path=(path||'').split('?')[0];
    if(!path)return null;
    if(!productCache.has(path))productCache.set(path,fetch(path+'.js',{credentials:'same-origin',headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).catch(()=>null));
    return productCache.get(path);
  }

  function matchingVariant(product,chosen){
    return (product?.variants||[]).find(v=>{
      const opts=(v.options||[]).map(norm);
      return opts.includes(norm(chosen.box))&&opts.includes(norm(chosen.style));
    })||null;
  }

  async function applySelectedProductVariant(){
    const chosen=selection();
    if(!chosen)return;
    const info=document.querySelector('product-info[data-url]');
    if(!info)return;
    const p=await getProduct(info.dataset.url);
    const v=matchingVariant(p,chosen);
    if(!v)return;
    const u=new URL(location.href);
    if(String(u.searchParams.get('variant')||'')===String(v.id))return;
    u.searchParams.set('variant',v.id);
    u.searchParams.set('style_name',chosen.style);
    u.searchParams.set('box_type',chosen.box);
    location.replace(u.toString());
  }

  function updateCardLinks(card,chosen,variantId){
    card.querySelectorAll('a[href*="/products/"]').forEach(a=>{
      try{
        const u=new URL(a.href,location.origin);
        u.searchParams.set('style_name',chosen.style);
        u.searchParams.set('box_type',chosen.box);
        if(variantId)u.searchParams.set('variant',variantId);
        a.href=u.pathname+u.search;
      }catch(e){}
    });
  }

  async function addVariantToCart(variantId,button){
    const original=button.textContent.trim();
    button.disabled=true;
    button.setAttribute('aria-busy','true');
    button.textContent='Adding…';
    try{
      const drawer=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
      const formData=new FormData();
      formData.append('id',variantId);
      formData.append('quantity','1');
      if(drawer&&typeof drawer.getSectionsToRender==='function'){
        formData.append('sections',drawer.getSectionsToRender().map(s=>s.id).join(','));
        formData.append('sections_url',location.pathname+location.search);
      }
      const res=await fetch(window.routes?.cart_add_url||'/cart/add.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest',Accept:'application/json'},body:formData});
      const data=await res.json();
      if(!res.ok||data.status)throw new Error(data.description||data.message||'Unable to add item');
      if(drawer&&typeof drawer.renderContents==='function'&&data.sections){
        drawer.renderContents(data);
      }else{
        const cart=await fetch('/cart.js',{credentials:'same-origin'}).then(r=>r.json());
        const bubble=document.querySelector('.cart-count-bubble');
        if(bubble){
          const spans=bubble.querySelectorAll('span');
          if(spans[0])spans[0].textContent=cart.item_count;
          bubble.classList.remove('hidden');
        }
      }
      button.textContent='Added ✓';
      button.classList.add('k4l-selected-added');
      setTimeout(()=>{button.textContent='Add to cart';button.disabled=false;button.removeAttribute('aria-busy');button.classList.remove('k4l-selected-added')},1500);
    }catch(e){
      button.textContent='Try again';
      button.disabled=false;
      button.removeAttribute('aria-busy');
      console.warn('Selected cabinet variant could not be added',e);
      setTimeout(()=>{button.textContent=original||'Add to cart'},1800);
    }
  }

  async function convertCollectionCard(card,chosen){
    if(card.dataset.k4lSelectedCart==='working'||card.dataset.k4lSelectedCart==='ready')return;
    const choose=card.querySelector('modal-opener button[data-product-url], button.quick-add__submit[data-product-url]');
    if(!choose)return;
    card.dataset.k4lSelectedCart='working';
    const path=choose.dataset.productUrl||card.querySelector('a[href*="/products/"]')?.getAttribute('href');
    const product=await getProduct(path);
    const variant=matchingVariant(product,chosen);
    if(!variant||variant.available===false){card.dataset.k4lSelectedCart='';return;}

    updateCardLinks(card,chosen,variant.id);
    const opener=choose.closest('modal-opener');
    const btn=choose.cloneNode(true);
    btn.removeAttribute('aria-haspopup');
    btn.removeAttribute('data-product-url');
    btn.removeAttribute('aria-labelledby');
    btn.type='button';
    btn.disabled=false;
    btn.innerHTML='<span>Add to cart</span>';
    btn.title=`Add ${chosen.style} / ${chosen.box}`;
    btn.setAttribute('aria-label',`Add ${product.title} — ${chosen.style}, ${chosen.box} to cart`);
    btn.dataset.k4lVariantId=variant.id;
    btn.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();addVariantToCart(variant.id,btn)});

    const wrap=document.createElement('div');
    wrap.className='k4l-selected-quick-add';
    wrap.append(selectedDoorVisual(chosen),btn);
    if(opener)opener.replaceWith(wrap); else choose.replaceWith(wrap);
    card.dataset.k4lSelectedCart='ready';
  }

  function enhanceCollectionCards(){
    const chosen=selection();
    if(!chosen||!location.pathname.startsWith('/collections/'))return;
    document.querySelectorAll('.product-card-wrapper, .card-wrapper.product-card-wrapper').forEach(card=>convertCollectionCard(card,chosen));
  }

  function addCss(){
    if(document.getElementById('sk-targeted-contrast-css'))return;
    const style=document.createElement('style');
    style.id='sk-targeted-contrast-css';
    style.textContent=`
      @media(max-width:749px){footer,.footer{color:rgba(255,255,255,.82)!important}footer a,footer p,footer li,footer span,footer small,.footer a,.footer p,.footer li,.footer span,.footer small{color:#f5f5f3!important;opacity:1!important}footer strong,footer h2,footer h3,footer h4,.footer strong,.footer h2,.footer h3,.footer h4{color:#fff!important;opacity:1!important}}
      .k4l-selected-quick-add{display:grid;gap:7px;width:100%}
      .k4l-door-selection{display:grid;grid-template-columns:40px minmax(0,1fr);gap:8px;align-items:center;padding:7px 8px;border:1px solid rgba(36,36,36,.13);border-radius:8px;background:#faf9f5;text-align:left;min-height:58px}
      .k4l-door-preview{width:36px;height:44px;display:block;position:relative;background:var(--k4l-door-color,#d8d5ce);border:1px solid rgba(0,0,0,.22);border-radius:2px;box-shadow:inset 0 0 0 1px rgba(255,255,255,.22),0 1px 2px rgba(0,0,0,.08)}
      .k4l-door-preview.k4l-shaker:after{content:'';position:absolute;inset:6px;border:2px solid rgba(0,0,0,.17);border-radius:1px;box-shadow:inset 0 0 0 1px rgba(255,255,255,.14)}
      .k4l-door-preview.k4l-slim-shaker:after{content:'';position:absolute;inset:4px;border:1px solid rgba(0,0,0,.2);border-radius:1px}
      .k4l-door-copy{min-width:0;display:grid;gap:1px;line-height:1.15}
      .k4l-door-eyebrow{font-size:8px;line-height:1.1;letter-spacing:.08em;text-transform:uppercase;color:#77736b;font-weight:700}
      .k4l-door-name{font-size:11px;line-height:1.2;color:#242424;font-weight:750;white-space:normal}
      .k4l-door-box{font-size:9px;line-height:1.2;color:#6a6761}
      .k4l-selected-quick-add .quick-add__submit{margin:0;width:100%}
      .k4l-selected-added{font-weight:800}
      @media(max-width:749px){.k4l-door-selection{grid-template-columns:35px minmax(0,1fr);padding:6px}.k4l-door-preview{width:31px;height:39px}.k4l-door-name{font-size:10px}}
    `;
    document.head.appendChild(style);
  }

  function fixPricingHero(){
    const candidates=[...document.querySelectorAll('section,div')].filter(el=>{const t=textOf(el);return t.includes('Build Your Kitchen Price Online')&&t.includes('Quote in 60 seconds')});
    const hero=candidates.sort((a,b)=>a.querySelectorAll('*').length-b.querySelectorAll('*').length)[0];
    if(!hero)return;
    hero.querySelectorAll('h1,h2,h3,p,li').forEach(el=>setColor(el,LIGHT));
    hero.querySelectorAll('div,span,strong,p').forEach(el=>{const t=textOf(el);if(t==='Quote in 60 seconds'||t==='No sign-up needed')setColor(el,'#111111')});
  }
  function fixLightSections(){document.querySelectorAll('h1,h2,h3,h4,p,span,a').forEach(el=>{if(textOf(el)==='A Better Way to Buy Your Kitchen')setColor(el,DARK)})}
  function fixFooter(){document.querySelectorAll('footer.footer,.footer').forEach(f=>{f.style.setProperty('background','#181b1f','important');f.style.setProperty('color','rgba(255,255,255,.82)','important');f.querySelectorAll('a,p,li,span,small').forEach(el=>setColor(el,'#f5f5f3'));f.querySelectorAll('strong,h2,h3,h4').forEach(el=>setColor(el,'#ffffff'))})}
  function removeStrayWizardControls(){document.querySelectorAll('[id^="sk-wizard"],[class*="sk-wizard"],[id^="sk-mobile-nav"]').forEach(el=>el.remove())}

  function enhanceStartKitchenPage(){
    if(location.pathname!==START_PAGE||!document.querySelector('[data-syk-root]')||document.getElementById('syk-sales-visuals'))return;
    const style=document.createElement('style');
    style.id='syk-sales-visuals';
    style.textContent=`
      .syk__kitchen-scene{background-image:linear-gradient(90deg,rgba(0,0,0,.08),rgba(0,0,0,0)),url('https://cdn.shopify.com/s/files/1/1035/4606/1083/files/kitchen4less-modern-kitchen-homepage-hero.png?v=1783460258')!important;background-size:cover!important;background-position:center!important}.syk__kitchen-scene>*{display:none!important}
      .syk__package-visual{background-size:cover!important;background-position:center!important}.syk__package-visual>*{display:none!important}
      .syk__package-card:nth-child(1) .syk__package-visual{background-image:url('https://cdn.shopify.com/s/files/1/1035/4606/1083/files/10_wall_blue_shaker.png?v=1783481718')!important}.syk__package-card:nth-child(2) .syk__package-visual{background-image:url('https://cdn.shopify.com/s/files/1/1035/4606/1083/files/10_x_10_white_shaker.png?v=1783482250')!important}.syk__package-card:nth-child(3) .syk__package-visual{background-image:url('https://cdn.shopify.com/s/files/1/1035/4606/1083/files/10x10x10_grey_shaker.png?v=1783482292')!important}
      .syk__category-card{position:relative;overflow:hidden;min-height:190px;background:#f4f1e8;background-size:cover;background-position:center}.syk__category-card:before{content:'';position:absolute;inset:0;background:linear-gradient(180deg,rgba(255,255,255,.16),rgba(255,255,255,.96) 64%);z-index:0}.syk__category-card>*{position:relative;z-index:1}
      .syk__style-card,.syk__box-card,.syk__path-card,.syk__package-card,.syk__category-card{transition:transform .18s ease,box-shadow .18s ease,border-color .18s ease}.syk__package-card:hover,.syk__category-card:hover{transform:translateY(-3px);box-shadow:0 14px 32px rgba(0,0,0,.10)}
    `;
    document.head.appendChild(style);
  }

  function run(){
    removeStrayWizardControls();addCss();fixPricingHero();fixLightSections();fixFooter();enhanceStartKitchenPage();applySelectedProductVariant();enhanceCollectionCards();
  }

  let timer;
  const observer=new MutationObserver(()=>{clearTimeout(timer);timer=setTimeout(enhanceCollectionCards,120)});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{run();observer.observe(document.body,{childList:true,subtree:true})},{once:true});
  else{run();observer.observe(document.body,{childList:true,subtree:true})}
  window.addEventListener('load',run,{once:true});
  document.addEventListener('shopify:section:load',run);
})();